import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';
import { AnalyticsStore, ContextStore, PageStore, ExperimentStore } from 'bernie-plugin-mobx';
import {
  AdvertisingStore,
  SearchCriteriaStore,
  ListingsStore,
  SearchFormStore,
  SortFilterStore,
  ErrorStore,
  DialogsStore,
  RewardsPricingInfoStore,
  PageTitleStore,
  ClientMetadataStore,
  FreeCancellationStore,
  FlightInformationStore,
  FlightServicingStore,
  FlightServicingConfirmationStore,
  ServicingCriteriaStore,
  ServicingConfirmationCriteriaStore,
  InformationCriteriaStore,
  MessagingCardsStore,
  BannersStore,
  PriceSummaryStore,
  FlexibleSearchResultsStore,
  SearchResultsStore,
  FlightsSelectedJourneyReviewStore,
  CheapestListingInfoStore,
  DynamicElementsStore,
  GaiaIdStore,
  StepIndicatorStore,
  OpinionLabStore,
  DetailsAndFaresStore,
  InformationMetaCriteriaStore,
  JourneyContinuationIdStore,
  JourneyStartEndDatesStore,
  MultiItemStore,
  SearchFormResponseStore,
  CreditRedemptionStore,
  FlightsSupportedAncillariesStore,
  InformationResultStore,
  ListingsHeaderPlacardsStore,
  FlightsInfoPriceMatchPromiseStore,
  VirtualAgentStore,
  VirtualAgentFlightCheckoutStore,
  PartnerEarnCardStore,
  FlightsSearchMetadataStore,
  FlightsMerchandisingCriteriaStore,
  FlightsMerchandisingStore,
  FlightsMerchandisingCheckoutStore,
  FlightsMerchandisingCheckoutCriteriaStore,
  FlightsMerchandisingConfirmationStore,
  FlightsMerchandisingConfirmationCriteriaStore
} from 'stores';
import { AdditionalShoppingStore } from 'stores/additional-shopping-store';

export interface FlightsStoresType {
  experiment: ExperimentStore;
  context: ContextStore;
  advertising: AdvertisingStore;
  searchCriteriaStore: SearchCriteriaStore;
  searchFormResponseStore: SearchFormResponseStore;
  searchResults: SearchResultsStore;
  analytics: AnalyticsStore;
  listingsStore: ListingsStore;
  searchFormStore: SearchFormStore;
  sortFilterStore: SortFilterStore;
  errorStore: ErrorStore;
  dialogsStore: DialogsStore;
  rewardsPricingInfoStore: RewardsPricingInfoStore;
  pageTitleStore: PageTitleStore;
  opinionLabStore: OpinionLabStore;
  clientMetadataStore: ClientMetadataStore;
  page: PageStore;
  flightInformationStore: FlightInformationStore;
  flightServicingStore: FlightServicingStore;
  flightServicingConfirmationStore: FlightServicingConfirmationStore;
  servicingCriteriaStore: ServicingCriteriaStore;
  servicingConfirmationCriteriaStore: ServicingConfirmationCriteriaStore;
  informationCriteriaStore: InformationCriteriaStore;
  informationMetaCriteriaStore: InformationMetaCriteriaStore;
  freeCancellationStore: FreeCancellationStore;
  messagingCardsStore: MessagingCardsStore;
  bannersStore: BannersStore;
  priceSummaryStore: PriceSummaryStore;
  flexibleSearchResultsStore: FlexibleSearchResultsStore;
  flightsSelectedJourneyReviewStore: FlightsSelectedJourneyReviewStore;
  cheapestListingInfoStore: CheapestListingInfoStore;
  dynamicElementsStore: DynamicElementsStore;
  gaiaIdStore: GaiaIdStore;
  stepIndicatorStore: StepIndicatorStore;
  detailsAndFaresStore: DetailsAndFaresStore;
  journeyContinuationIdStore: JourneyContinuationIdStore;
  journeyStartEndDatesStore: JourneyStartEndDatesStore;
  multiItemStore: MultiItemStore;
  informationResult: InformationResultStore;
  creditRedemptionStore: CreditRedemptionStore;
  flightsSupportedAncillariesStore: FlightsSupportedAncillariesStore;
  listingsHeaderPlacardsStore: ListingsHeaderPlacardsStore;
  flightsInfoPriceMatchPromiseStore: FlightsInfoPriceMatchPromiseStore;
  virtualAgentStore: VirtualAgentStore;
  virtualAgentFlightCheckoutStore: VirtualAgentFlightCheckoutStore;
  partnerEarnCardStore: PartnerEarnCardStore;
  flightsSearchMetadataStore: FlightsSearchMetadataStore;
  additionalShoppingStore: AdditionalShoppingStore;
  flightsMerchandisingCriteriaStore: FlightsMerchandisingCriteriaStore;
  flightsMerchandisingStore: FlightsMerchandisingStore;
  flightsMerchandisingCheckoutCriteriaStore: FlightsMerchandisingCheckoutCriteriaStore;
  flightsMerchandisingCheckoutStore: FlightsMerchandisingCheckoutStore;
  flightsMerchandisingConfirmationCriteriaStore: FlightsMerchandisingConfirmationCriteriaStore;
  flightsMerchandisingConfirmationStore: FlightsMerchandisingConfirmationStore;
}

export const useStores = (): FlightsStoresType => React.useContext(MobXProviderContext);
